<template>
    <div id="index">
        <my-header></my-header>
        <div class="swiper-container bigSwiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide slide1" data-hash="slide1">
                    <img class="bg1" src="../assets/images/index/bg1.jpg"/>
                    <img class="text" src="../assets/images/index/text.png"/>
                </div>
                <div class="swiper-slide slide2" data-hash="slide2">
                    <section >
                        <h3 class="title_1">
                            <img src="../assets/images/index/tit01.png"/>
                            <span @click="toInviteList" class="view">查看更多&gt;&gt;</span>
                        </h3>
                        <el-row v-if="lstTenderBidMessageResponseVO.length">
                            <el-col :span="12" v-for="(item,i) in lstTenderBidMessageResponseVO" :key="i">
                                <div class="left">
                                    <img :src='"../assets/images/index/0"+(i+1)+".png"'>
                                </div>
                                <div class="right">
                                    <div>
                                        <h4 class="overflowH" @click="$router.push('/invite-listDetail/'+item.id)">{{item.msgTitle}}</h4>
                                        <strong v-if="item.deadlineTime">
                                            <span>{{ item.deadlineTime.split(' ')[0] }}</span>
                                            结束报名
                                        </strong>
                                    </div>
                                    <p v-if="item.msgContent">简介：{{ item.msgContent }}</p>
                                </div>
                            </el-col>
                        </el-row>
                        <p v-else class="none">------ 暂无招标公告 ------</p>
                    </section>
                </div>
                <div class="swiper-slide slide3" data-hash="slide3">
                    <img class="bg3" src="../assets/images/index/bg3.png"/>
                    <section >
                        <img style="height:42px;" src="../assets/images/index/tit02.png"/>
                        <ul v-if="lstWinBidMessageResponseVO.length">
                            <li v-for="(item,i) in lstWinBidMessageResponseVO" :key="i" >
                                <p class="overflowT">{{ item.msgTitle }}</p>
                                <strong v-if="item.bidTime">--<span>{{ item.bidTime.split(' ')[0] }}</span></strong>
                            </li>
                        </ul>
                        <p v-else class="none">------ 暂无中标公告 ------</p>
                        <span class="more view" @click="toWinList">查看更多</span>
                    </section>
                </div>
                <div class="swiper-slide slide4" data-hash="slide4">
                    <div class="main-container">
<!--                        <img src="../assets/images/index/tit03.png"/>-->
<!--                        <div class="swiper-container smallSwiper" v-if="lstStrategicPartnersResponseVO.length">-->
<!--                            <div class="swiper-wrapper">-->
<!--                                <div class="swiper-slide">-->
<!--                                    <el-row>-->
<!--                                        <el-col :span="8" v-for="(item,i) in lstStrategicPartnersResponseVO" :key="i">-->
<!--                                            <img :src="item.attachmentVo.imgUrl" :title="item.partnerName"/>-->
<!--                                        </el-col>-->
<!--                                    </el-row>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="swiper-button-next smallSwiperNext"></div>-->
<!--                            <div class="swiper-button-prev smallSwiperPrev"></div>-->
<!--                        </div>-->
<!--                        <p v-else class="none">&#45;&#45;&#45;&#45;&#45;&#45; 暂无战略合作伙伴 &#45;&#45;&#45;&#45;&#45;&#45;</p>-->
                    </div>
                    <my-footer></my-footer>
                </div>
            </div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-next bigSwiperNext"></div>
        </div>
    </div>

</template>
<script type="text/babel">
    import MyHeader from './common/Header'
    import MyFooter from './common/Footer'
    import Swiper from 'swiper'
    import util from '../util/index'
    export default {
        name: 'index',
        data(){
            return {
                hashVal: '',
                lstTenderBidMessageResponseVO: [],//招标公告
                lstWinBidMessageResponseVO: [],//中标公告
                lstStrategicPartnersResponseVO: [],//战略合作伙伴
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            let _this = this;
            this.$root.getHttp('v1/login/public/getRestIndex',function(res){
                _this.lstTenderBidMessageResponseVO = res.data.data.lstTenderBidMessageResponseVO || [];
                _this.lstWinBidMessageResponseVO = res.data.data.lstWinBidMessageResponseVO || [];
                _this.lstStrategicPartnersResponseVO = res.data.data.lstStrategicPartnersResponseVO || [];
                if(_this.lstStrategicPartnersResponseVO.length){
                    _this.lstStrategicPartnersResponseVO.forEach((item)=>{
                        if(item.attachmentVo){
                            item.attachmentVo['imgUrl'] = util.baseUrl+'/v1/public/download/download_direct?attachmentPath='+item.attachmentVo.attachPath+'&attachmentName='+encodeURIComponent(item.attachmentVo.attachName);
                        }
                    });
                }
            })
        },
        mounted(){
            var loginRightEl = document.getElementsByClassName('loginRight');
            if(loginRightEl.length){
                loginRightEl[0].className = 'loginRight loginIndex'
            }
            var bigSwiperNextEl = document.querySelector('.bigSwiperNext');
            var mySwiper = new Swiper(".bigSwiper", {
                direction: "vertical",
//                height: window.innerHeight,
                hashnav:true,//拖动会切换对应的hash值；
                keyboardControl : true,
//                autoHeight: true,
                pagination: '.swiper-pagination',
                paginationType : 'custom',//自定义分页器
                paginationClickable :true,//分页器可点击切换
//                bulletClass: 'swiper-pagination-bullet',
                paginationBulletRender: function (swiper, index, className) {
//                    return '<span class="swiper-pagination-bullet"></span>';
                },
                nextButton: '.bigSwiperNext',
                mousewheelControl : true,//鼠标滚动可以控制切换；
                observer:true,//window.resize，Swiper更新
                observeParents:true,
                onSlideChangeEnd: function(swiper){
//                    console.log(swiper,swiper.activeIndex)
                    if (swiper.activeIndex <= 3) {
                        bigSwiperNextEl.style.display = 'block';
                    } else {
                        bigSwiperNextEl.style.display = 'none';
                    }
                }
            });
            new Swiper(".smallSwiper", {
                loop: false,
                height: 240,
                nextButton: '.smallSwiperNext',
                prevButton: '.smallSwiperPrev',
            });
        },
        methods: {
            toInviteList(){//招标公告
                this.$root.activeIndex = 'invite';
                this.$router.push( '/invite-list');
            },
            toWinList(){//中标公告
                this.$root.activeIndex = 'win';
                this.$router.push('/win-list');
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../assets/_var.scss";
    @import "../assets/swiper.min.css";
    html ,body {
        height: 100%;
    }
    html {
        overflow: hidden;
    }
    .swiper-container {
        width: 100%;
    }
    .bigSwiper{
         &>.swiper-wrapper {
            height: 100vh;
             swiper-slide {
                 height: 100vh;
             }
         }
        & .swiper-pagination-bullet {
            width: 20px;
            height: 5px;
            border-radius: 0;
            opacity: .5;
            background: #ccc;
        }
        & .swiper-pagination-bullets .swiper-pagination-bullet {
            margin: 12px 0;
        }
        & .swiper-pagination-bullets .swiper-pagination-bullet-active {
            width: 27px;
            margin-left: -7px;
            background: #fff;
            opacity: .8;
        }

    }
    .bigSwiperNext {
        /*bottom: 10px;*/
        /*top: unset;*/
        top: 90%;
        left: 50%;
        width: 30px;
        height: 30px;
        margin: 0 0 0 -15px;
        background-size: contain;
        background-image: url('../assets/images/index/arrow.png');
        transform: scale(1);
        transition: 1s;
    }
    .bigSwiperNext:hover {
        transform: scale(1.1);
        background-image: url('../assets/images/index/arrtow2.png');
    }
    .slide1{
        position: relative;
    }
    .bg1 {
        display: block;
        width: 100%;
        height: 100vh;
    }
    .text {
        width: 40%;
        height: auto;
        position: absolute;
        left: 50%;
        top: 27.5%;
        transform: translateX(-50%);
    }
    .slide2 {
        background: url('../assets/images/index/bg2.jpg') no-repeat;
        background-size: 100% 100%;
    }
    .slide2 section{
        margin: 150px auto;
        box-sizing: border-box;
        padding: 20px;
        width: 1150px;
        height: 414px;
        background: rgba(255,255,255,1);
        box-shadow: 0 0 25px rgba(0,0,0,.3);
        .el-row {
            cursor: pointer;
        }
        .overflowH {
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .title_1{
        margin: 10px 0 20px;
        overflow: hidden;
    }
    .title_1 img {
        float: left;
        height: 26px;
    }
    .title_1 span {
        float: right;
        font-weight: normal;
        color: $--text-color-light;
    }
   /* .title_1 span::after {
        content: '';
        display: inline-block;
        margin: 0px 0 0 8px;
        width: 10px;
        height: 13px;
        background: url('../assets/images/index/more.png') no-repeat;
        background-size: contain;
    }*/
    .slide2 .el-col {
        height: 75px;
    }
    .slide2 .left {
        float: left;
        padding: 20px;
        background: $--secondary-fill-color;
        text-align: center;
        & img {
            width: 35px;
            height: auto;
        }
    }
    .slide2 .right {
        float: left;
        width: 85%;
        box-sizing: border-box;
        padding-left: 10px;
        & div{
            overflow: hidden;
            & h4 {
                margin: 0;
                line-height: 30px;
                float: left;
                font-size: 14px;
            }
            & h4:hover {
                color: $--primary-color;
                text-decoration: underline;
            }
            & strong {
                float: right;
                font-weight: normal;
                font-size: 12px;
                line-height: 30px;
                color: $--text-color-lighter;
            }
        }
        & p {
            margin: 0;
            text-align: left;
            font-size: 12px;
            color: $--text-color-lighter;
        }
    }
    .slide3 {
        position: relative;
        /*background: url('../assets/images/index/bg3.png') no-repeat 0 0/100% 100%;*/
        .bg3 {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        & section{
            position: relative;
            margin: 130px auto;
            box-sizing: border-box;
            padding: 30px 50px;
            width: 800px;
            height: 414px;
            background: rgba(255,255,255,.85);
            box-shadow: 0 0 15px rgba(0,0,0,.2);
            & li {
                padding-left: 30px;
                background: url('../assets/images/index/listIcon.png') no-repeat 0 center/15px 15px;
                text-align: left;
                overflow: hidden;
                font-size: 14px;
                line-height: 35px;
               // cursor: pointer;
                & p {
                    float: left;
                }
                & p:hover {
                   // color: $--primary-color;
                   // text-decoration: underline;
                }
                .overflowT {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 500px;
                }
                & strong {
                    float: right;
                    color: $--text-color-lighter;
                    font-weight: normal;
                }
            }
            & .more {
                position: absolute;
                right: -35px;
                bottom: 30px;
                width: 122px;
                height: 32px;
                opacity: 1;
                transition: .3s;
                background: url('../assets/images/index/btnBg.png') no-repeat 0 0/contain;
                color: #fff;
                text-align: center;
                font-size: 12px;
                line-height: 32px;
                &::after {
                    content: '';
                    display:inline-block;
                    vertical-align: middle;
                    margin-left: 10px;
                    width: 12px;
                    height: 12px;
                    background: url('../assets/images/index/more2.png') no-repeat 0 0/contain;
                }
            }
        }
    }
    .slide4 {
        position: relative;
        & .main-container {
            margin-top: 100px;
            height: 302px;
            & img {
                display: block;
                margin: 0 auto;
                height: 42px;
            }
            & .smallSwiper {
                margin: 20px auto 0;
                width: 1000px;

                & .el-col {
                    height: 80px;
                    overflow: hidden;
                    text-align: center;
                    cursor: pointer;
                    & img {
                        width: 130px;
                        height: 70px;
                    }
                }
            }
            & .swiper-button-prev{
                width: 44px;
                background: url('../assets/images/index/Arrow_r.png') no-repeat 0 0/44px 44px;
            }
            & .swiper-button-next {
                width: 44px;
                background: url('../assets/images/index/Arrow_l.png') no-repeat 0 0/44px 44px;
            }
            .smallSwiperPrev,
            .smallSwiperNext {
                opacity: .8;
                transform: scale(1);
                transition: .3s;
            }
            .smallSwiperPrev:hover,
            .smallSwiperNext:hover {
                opacity: 1;
                transform: scale(1.1);
            }
        }
      /*  .foot-bg {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
        }*/
    }
    #index {
        .view {
            cursor: pointer;
        }
        .view:hover {
            color: $--text-color;
        }
        .more:hover {
            opacity: .8;
            color: #fff;
        }
        .none {
            margin: 55px 0 70px;
            font-size: 16px;
            line-height: 40px;
            color: $--text-color-lighter;
            border: none;
        }
    }
    .head-top .loginIndex {
        border-bottom: 1px solid #fff;
        p {
            color: #fff;
            .backIndex {
                background: url('../assets/images/masterCenter/topBar/icon_01.png') no-repeat 10px center;
            }
            .helpT {
                background: url('../assets/images/masterCenter/topBar/icon_02.png') no-repeat 10px center;
            }
            .wechatT {
                background: url('../assets/images/masterCenter/topBar/icon_03.png') no-repeat 10px center;
            }
            .loginOut {
                background: url('../assets/images/masterCenter/topBar/icon_04.png') no-repeat 10px center;
            }
            .line {
                background: #fff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue